import { Box } from '@mantine/core';
import { keyframes } from '../utils/keyframes';
import { forwardRef } from 'react';
import { useReducedMotion } from '../hooks';

export interface HeartbeatProps {
  children: React.ReactNode;
  active?: boolean;
  duration?: number;
  scale?: number;
  infinite?: boolean;
  count?: number;
}

const Heartbeat = forwardRef<HTMLDivElement, HeartbeatProps>(
  (
    {
      children,
      active = true,
      duration = 1300,
      scale = 1.15,
      infinite = true,
      count = 1,
    },
    ref
  ) => {
    const reducedMotion = useReducedMotion();

    if (reducedMotion || !active) {
      return <Box ref={ref}>{children}</Box>;
    }

    const iterationCount = infinite ? 'infinite' : count;

    const heartbeatKeyframes = keyframes({
      '0%': { transform: 'scale(1)' },
      '14%': { transform: `scale(${scale})` },
      '28%': { transform: 'scale(1)' },
      '42%': { transform: `scale(${scale})` },
      '70%': { transform: 'scale(1)' },
    });

    return (
      <Box
        ref={ref}
        style={{
          animation: `${heartbeatKeyframes} ${duration}ms ease-in-out ${iterationCount}`,
          display: 'inline-block',
        }}
      >
        {children}
      </Box>
    );
  }
);

Heartbeat.displayName = 'Heartbeat';

export default Heartbeat;
